module.exports = __webpack_public_path__ + "../public/img/logo.0a0604d4.png";